interface TimedValue {
  startSeconds: number
  endSeconds: number
  label: string
  displayValue?: string
}

const MIN_LABEL_WIDTH = 28
const MAX_LABEL_WIDTH = 96
const LABEL_PADDING = 12
const CHARACTER_WIDTH = 7
const VALUE_GAP = 6

export function layoutAudioTimedValues<T extends TimedValue>(
  points: T[],
  durationMs: number,
  trackWidth: number,
) {
  const width = Math.max(1, trackWidth)
  const laneEnds: number[] = []
  return points
    .map((point, index) => ({ point, index }))
    .sort((a, b) => a.point.startSeconds - b.point.startSeconds)
    .map(({ point, index }) => {
      const start = Math.max(
        0,
        Math.min(width, (point.startSeconds * 1000 * width) / durationMs),
      )
      const end = Math.max(
        start,
        Math.min(width, (point.endSeconds * 1000 * width) / durationMs),
      )
      const labelWidth = Math.min(
        width,
        MAX_LABEL_WIDTH,
        Math.max(
          MIN_LABEL_WIDTH,
          (point.displayValue ?? point.label).length * CHARACTER_WIDTH +
            LABEL_PADDING,
        ),
      )
      const labelLeft = Math.max(
        0,
        Math.min(width - labelWidth, (start + end - labelWidth) / 2),
      )
      const left = Math.min(start, labelLeft)
      const right = Math.max(end, labelLeft + labelWidth)
      let lane = laneEnds.findIndex((laneEnd) => laneEnd + VALUE_GAP <= left)
      if (lane === -1) {
        lane = laneEnds.length
      }
      laneEnds[lane] = right
      return {
        point,
        index,
        start,
        end,
        labelLeft,
        labelWidth,
        left,
        right,
        lane,
      }
    })
}
